module.exports = __webpack_public_path__ + "img/jack.930a3615.png";